import React from 'react';

const NAV_BTN = (enabled) => ({
    flex: 1,
    height: '48px',
    borderRadius: '10px',
    border: '1px solid #d8d0bd',
    backgroundColor: '#fff',
    color: '#333',
    fontSize: '24px',
    lineHeight: 1,
    cursor: enabled ? 'pointer' : 'default',
    opacity: enabled ? 1 : 0.35
});

const ScrollArrows = ({
    mealType,
    shouldShowArrows,
    itemCount,
    scrollState,
    onScrollLeft,
    onScrollRight
}) => {
    if (!shouldShowArrows(itemCount, mealType)) return null;

    return (
        <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
            <button
                type="button"
                aria-label="Scroll left"
                disabled={!scrollState.canScrollLeft}
                style={NAV_BTN(scrollState.canScrollLeft)}
                onClick={() => onScrollLeft(mealType)}
            >
                ‹
            </button>
            <button
                type="button"
                aria-label="Scroll right"
                disabled={!scrollState.canScrollRight}
                style={NAV_BTN(scrollState.canScrollRight)}
                onClick={() => onScrollRight(mealType)}
            >
                ›
            </button>
        </div>
    );
};

export default ScrollArrows;
